package com.example.histoire.web

/**
 * Domaines d’e-mail de test / jetables : pas d’inscription (aligné avec le hook Auth Supabase).
 */
private val BLOCKED_SIGNUP_EMAIL_DOMAINS: Set<String> =
    setOf(
        "example.com",
        "example.org",
        "example.net",
        "test.com",
        "test.test",
        "invalid.com",
        "mailinator.com",
        "yopmail.com",
        "guerrillamail.com",
        "guerrillamail.de",
        "tempmail.com",
        "10minutemail.com",
        "throwaway.email",
        "sharklasers.com",
    )

private const val BLOCKED_SIGNUP_EMAIL_MESSAGE_FR =
    "Cette adresse e-mail (domaine de test ou jetable) ne peut pas être utilisée pour créer un compte. " +
        "Utilise une vraie adresse e-mail."

/** @return message d’erreur utilisateur, ou `null` si l’adresse est acceptée pour l’inscription. */
fun blockedSignupEmailMessage(email: String): String? {
    val domain = email.trim().lowercase().substringAfterLast('@', missingDelimiterValue = "")
    if (domain.isBlank()) return null
    return if (domain in BLOCKED_SIGNUP_EMAIL_DOMAINS) {
        BLOCKED_SIGNUP_EMAIL_MESSAGE_FR
    } else {
        null
    }
}
